var map = {
	"./data_exports.gif": 955,
	"./insights_page.gif": 956
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;



//////////////////
// WEBPACK FOOTER
// ./assets/images/features .\.gif*
// module id = 364
// module chunks = 0